import { useMutation } from '@apollo/client';
import { PricingTaxi } from '../../shared/types';
import { CITRIN_UPDATE_PRICING_TAXI, UpdatePricingTaxiRequest, UpdatePricingTaxiResponse } from '..';

type UpdateMutationFunction = (request: PricingTaxi) => Promise<PricingTaxi>;
export const useUpdatePricingTaxiMutation = (): { mutation: UpdateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<UpdatePricingTaxiResponse, UpdatePricingTaxiRequest>(
        CITRIN_UPDATE_PRICING_TAXI
    );

    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_updatePricingTaxi;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
